export const USER_ADD_USER = 'user/add';
export const USER_UPDATE_USER = 'user/update';
export const USER_UPDATE_USER_ASYNC = 'user/update/async';
export const USER_UPDATE_USER_FAILED = 'user/update/failed';
export const USER_CREATE_IDENTIFICATION = 'user/identification/create';
export const USER_CREATE_IDENTIFICATION_ASYNC = 'user/identification/create/async';
export const USER_CREATE_IDENTIFICATION_FAILED = 'user/identification/create/failed';
export const USER_UPDATE_IDENTIFICATION = 'user/identification/update';
export const USER_UPDATE_IDENTIFICATION_ASYNC = 'user/identification/update/async';
export const USER_UPDATE_IDENTIFICATION_FAILED = 'user/identification/update/failed';
export const USER_CREATE_ADVISOR_CALL_EVENT = 'user/advisor_call_event/create';
export const USER_CREATE_ADVISOR_CALL_EVENT_ASYNC = 'user/advisor_call_event/create/async';
export const USER_CREATE_ADVISOR_CALL_EVENT_FAILED = 'user/advisor_call_event/create/failed';
export const USER_CREATE_PAYMENT_INFORMATION = 'user/payment_information/create';
export const USER_CREATE_PAYMENT_INFORMATION_FAILED = 'user/payment_information/create/failed';
export const USER_CREATE_PAYMENT_INFORMATION_ASYNC = 'user/payment_information/create/async';
export const USER_UPDATE_UNDERWRITING_REQUIREMENT = 'user/underwriting_requirement/update';
export const USER_UPDATE_UNDERWRITING_REQUIREMENT_FAILED = 'user/underwriting_requirement/update/failed';
export const USER_UPDATE_UNDERWRITING_REQUIREMENT_ASYNC = 'user/underwriting_requirement/update/async';
export const USER_UPDATE_UNDERWRITING_DOCUMENT = 'user/underwriting_document/update';
export const USER_UPDATE_UNDERWRITING_DOCUMENT_FAILED = 'user/underwriting_document/update/failed';
export const USER_UPDATE_UNDERWRITING_DOCUMENT_ASYNC = 'user/underwriting_document/update/async';
export const USER_UPDATE_CONSENT = 'user/update_consent';
export const USER_UPDATE_CONSENT_ASYNC = 'user/update_consent/async';
export const USER_UPDATE_CONSENT_FAILED = 'user/update_consent/failed';
export const USER_CREATE_EMPLOYMENT_INFO = 'user/employment_info/create';
export const USER_CREATE_EMPLOYMENT_INFO_ASYNC = 'user/employment_info/create/async';
export const USER_CREATE_EMPLOYMENT_INFO_FAILED = 'user/employment_info/create/failed';
export const USER_UPDATE_EMPLOYMENT_INFO = 'user/employment_info/update';
export const USER_UPDATE_EMPLOYMENT_INFO_ASYNC = 'user/employment_info/update/async';
export const USER_UPDATE_EMPLOYMENT_INFO_FAILED = 'user/employment_info/update/failed';
export const DOCUSIGN_REQUIREMENT_UPDATE = 'user/underwriting_requirements/docusign-redirect';
